module.exports = __webpack_public_path__ + "assetst/img/desktop.75294ca7.svg";